module.exports = __webpack_public_path__ + "img/5.eee4d740.jpg";